import toast from 'react-hot-toast';

const notify = (type, text) => toast[type](text, { position: 'top-right' });
  
export default notify;
